document.addEventListener('DOMContentLoaded', function() {
  const slideshow = document.getElementById('premium-slideshow');
  if (!slideshow) return;
  
  const container = slideshow.querySelector('.premium-slideshow-columns-container');
  if (!container) return;
  
  // Get all columns
  const originalColumns = Array.from(container.querySelectorAll('.premium-slideshow-column')).filter(col => !col.classList.contains('clone'));
  const totalSlides = originalColumns.length;
  
  // Check if mobile
  let isMobile = window.innerWidth <= 768;
  let currentIndex = 0;
  let isAnimating = false;
  
  // Clear any existing clones
  container.querySelectorAll('.clone').forEach(clone => clone.remove());
  
  // Create infinite carousel structure
  function createInfiniteStructure() {
    // Clone slides for infinite effect
    originalColumns.forEach(column => {
      const clone = column.cloneNode(true);
      clone.classList.add('clone');
      container.appendChild(clone);
    });
  }
  
  // Force proper column widths
  function forceColumnWidths() {
    const grid = slideshow.querySelector('.premium-slideshow-grid');
    if (!grid) return;
    
    const gridWidth = grid.offsetWidth;
    const allColumns = container.querySelectorAll('.premium-slideshow-column');
    
    if (isMobile) {
      // Mobile: Full width columns
      allColumns.forEach(column => {
        column.style.cssText = `
          width: ${gridWidth}px !important;
          min-width: ${gridWidth}px !important;
          max-width: ${gridWidth}px !important;
          flex: 0 0 ${gridWidth}px !important;
        `;
      });
      
      container.style.width = (allColumns.length * gridWidth) + 'px';
    } else {
      // Desktop: Exactly 1/3 width columns
      const columnWidth = Math.floor(gridWidth / 3);
      
      allColumns.forEach(column => {
        column.style.cssText = `
          width: ${columnWidth}px !important;
          min-width: ${columnWidth}px !important;
          max-width: ${columnWidth}px !important;
          flex: 0 0 ${columnWidth}px !important;
        `;
      });
      
      container.style.width = (allColumns.length * columnWidth) + 'px';
    }
  }
  
  // Apply mobile focal points
  function applyMobileFocalPoints() {
    if (!isMobile) return;
    
    const allColumns = container.querySelectorAll('.premium-slideshow-column');
    allColumns.forEach(column => {
      const bg = column.querySelector('.premium-slideshow-column-background');
      if (!bg) return;
      
      // Check if focal point is already set in the inline style
      const currentStyle = bg.getAttribute('style') || '';
      if (!currentStyle.includes('background-position') || currentStyle.includes('center center')) {
        bg.style.backgroundPosition = 'center 30%';
      }
    });
  }
  
  // Move carousel to specific index
  function moveTo(index, animate = true) {
    if (isAnimating && animate) return;
    
    const grid = slideshow.querySelector('.premium-slideshow-grid');
    if (!grid) return;
    
    const gridWidth = grid.offsetWidth;
    const moveDistance = isMobile ? gridWidth : Math.floor(gridWidth / 3);
    const translateX = -(index * moveDistance);
    
    if (animate) {
      isAnimating = true;
      container.style.transition = 'transform 0.4s ease';
      
      setTimeout(() => {
        isAnimating = false;
        checkInfiniteLoop();
      }, 400);
    } else {
      container.style.transition = 'none';
      // Force reflow
      container.offsetHeight;
    }
    
    container.style.transform = `translateX(${translateX}px)`;
    currentIndex = index;
  }
  
  // Handle infinite loop
  function checkInfiniteLoop() {
    if (currentIndex >= totalSlides) {
      // Reset to beginning without animation
      currentIndex = 0;
      setTimeout(() => moveTo(0, false), 10);
    } else if (currentIndex < 0) {
      // Jump to end without animation
      currentIndex = totalSlides - 1;
      setTimeout(() => moveTo(totalSlides - 1, false), 10);
    }
  }
  
  // Navigation functions
  function goNext() {
    if (isAnimating) return;
    moveTo(currentIndex + 1);
  }
  
  function goPrevious() {
    if (isAnimating) return;
    
    if (currentIndex === 0) {
      // Jump to last clone, then animate
      moveTo(totalSlides, false);
      setTimeout(() => {
        moveTo(totalSlides - 1);
      }, 20);
    } else {
      moveTo(currentIndex - 1);
    }
  }
  
  // Setup navigation buttons
  function setupNavigation() {
    const prevBtn = slideshow.querySelector('.premium-slideshow-prev');
    const nextBtn = slideshow.querySelector('.premium-slideshow-next');
    
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goPrevious();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goNext();
      });
    }
  }
  
  // Touch support for mobile
  function setupTouchSupport() {
    let startX = 0;
    let startY = 0;
    let endX = 0;
    let endY = 0;
    const threshold = 50;
    
    container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    
    container.addEventListener('touchmove', (e) => {
      endX = e.touches[0].clientX;
      endY = e.touches[0].clientY;
    }, { passive: true });
    
    container.addEventListener('touchend', (e) => {
      const diffX = startX - endX;
      const diffY = startY - endY;
      
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > threshold) {
        if (diffX > 0) {
          goNext();
        } else {
          goPrevious();
        }
      }
    }, { passive: true });
  }
  
  // Fullscreen functionality
  function setupFullscreen() {
    const slidesContainer = slideshow.querySelector('.premium-slideshow-slides-container');
    const fullscreenSlides = slideshow.querySelectorAll('.premium-slideshow-slide');
    const closeBtn = slideshow.querySelector('.premium-slideshow-fullscreen-close');
    const fullscreenPrev = slideshow.querySelector('.premium-slideshow-fullscreen-prev');
    const fullscreenNext = slideshow.querySelector('.premium-slideshow-fullscreen-next');
    
    let fullscreenIndex = 0;
    
    // Click column to open fullscreen
    container.addEventListener('click', (e) => {
      const column = e.target.closest('.premium-slideshow-column');
      if (!column || e.target.closest('.premium-slideshow-button')) return;
      
      const allColumns = Array.from(container.querySelectorAll('.premium-slideshow-column'));
      const index = allColumns.indexOf(column);
      
      if (index !== -1) {
        fullscreenIndex = index % totalSlides;
        openFullscreen(fullscreenIndex);
      }
    });
    
    function openFullscreen(index) {
      slideshow.classList.add('fullscreen');
      document.body.style.overflow = 'hidden';
      
      fullscreenSlides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
    }
    
    function closeFullscreen() {
      slideshow.classList.remove('fullscreen');
      document.body.style.overflow = '';
      fullscreenSlides.forEach(slide => slide.classList.remove('active'));
    }
    
    function showFullscreenSlide(index) {
      fullscreenSlides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
    }
    
    // Fullscreen navigation
    if (fullscreenPrev) {
      fullscreenPrev.addEventListener('click', (e) => {
        e.stopPropagation();
        fullscreenIndex = (fullscreenIndex - 1 + totalSlides) % totalSlides;
        showFullscreenSlide(fullscreenIndex);
      });
    }
    
    if (fullscreenNext) {
      fullscreenNext.addEventListener('click', (e) => {
        e.stopPropagation();
        fullscreenIndex = (fullscreenIndex + 1) % totalSlides;
        showFullscreenSlide(fullscreenIndex);
      });
    }
    
    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closeFullscreen);
    }
    
    // Close on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && slideshow.classList.contains('fullscreen')) {
        closeFullscreen();
      }
    });
    
    // Close on background click
    slidesContainer?.addEventListener('click', (e) => {
      if (e.target === slidesContainer) {
        closeFullscreen();
      }
    });
  }
  
  // Auto-play functionality
  function setupAutoplay() {
    const autoplaySpeed = parseInt(slideshow.dataset.autoplaySpeed || 0) * 1000;
    if (autoplaySpeed === 0) return;
    
    let autoplayInterval = setInterval(goNext, autoplaySpeed);
    
    // Pause on hover
    slideshow.addEventListener('mouseenter', () => {
      clearInterval(autoplayInterval);
    });
    
    slideshow.addEventListener('mouseleave', () => {
      if (!slideshow.classList.contains('fullscreen')) {
        clearInterval(autoplayInterval);
        autoplayInterval = setInterval(goNext, autoplaySpeed);
      }
    });
    
    // Pause in fullscreen
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          clearInterval(autoplayInterval);
          if (!slideshow.classList.contains('fullscreen') && !slideshow.matches(':hover')) {
            autoplayInterval = setInterval(goNext, autoplaySpeed);
          }
        }
      });
    });
    
    observer.observe(slideshow, { attributes: true });
  }
  
  // Initialize everything
  function init() {
    createInfiniteStructure();
    forceColumnWidths();
    applyMobileFocalPoints();
    setupNavigation();
    setupTouchSupport();
    setupFullscreen();
    setupAutoplay();
    
    // Start at first slide
    moveTo(0, false);
    
    // Ensure widths are correct after a brief delay
    setTimeout(forceColumnWidths, 100);
  }
  
  // Initialize
  init();
  
  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const newIsMobile = window.innerWidth <= 768;
      const wasResized = newIsMobile !== isMobile;
      
      isMobile = newIsMobile;
      forceColumnWidths();
      
      if (wasResized) {
        // Device type changed, adjust position
        moveTo(currentIndex, false);
      }
    }, 250);
  });
  
  // Ensure proper display on page load
  window.addEventListener('load', () => {
    forceColumnWidths();
    moveTo(0, false);
  });
});